import React from "react";
import { HiOutlineViewGridAdd } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { checkSubscriptionExpiry } from "../../helpers";
import {
  activeCommunity,
  setIsSkip,
  setLastActiveCommunity,
  setPendingCommunityList,
} from "../../store/authSlice";
import MySelect from "../MySelect";
import classes from "./ToggleCommunity.module.css";
import { useNavigate } from "react-router-dom";
import { editResidenceCommunityList } from "../../helpers";
import useGeneralApi from "../../Hooks/useGeneralApi";
import { DEFAULT_ROLE_NAME } from "../../data/index";
import { useLoadingStore } from "../../contextApi/toggleLoader";
import { useLocation } from "react-router-dom";
import useLoader from "../../Hooks/useLoader";
import { setSubscriptionExpired } from "../../store/subscriptionExpired";
const ToggleCommunity = () => {

  const { loading, setLoading } = useLoader()

  console.log("Current loading", loading);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { communitiesList, communityId, communityName, communityCode, user } = useSelector(
    (state) => state?.authReducer
  );
  const { actions } = useLoadingStore()
  const location = useLocation();

  console.log("Location--", location);
  const handleChange = async (value) => {
    console.log("Handle Change", value)
    setLoading(true)
    const selectedCommunity = communitiesList?.find(
      (item) => item?.communityId === value?.value
    );
    checkSubscriptionExpiry(selectedCommunity)
    // debugger;
    await dispatch(activeCommunity(editResidenceCommunityList(selectedCommunity)));
    setLoading(false)
    // window.location.href = "/";
    navigate("/", { state: { toggle: true } });
    // navigate("/");
    // setTimeout(() => {
    //   window.location.reload();
    // }, 500);
  };

  // const updatedCommunityList = communitiesList?.filter(
  //   (item) => (item?.isSuperUser ? item?.isSetupCompleted ? true : false : true) && (item?.communityName !== "Quantum Paradigm")
  // );
  const updatedCommunityList = communitiesList?.filter(
    (item) => {

      return (item?.isSuperUser ? item?.isSetupCompleted ? true : false : true) && (item.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME)
    }
  );



  return (
    <>
      <div className={classes["community-dropdown"]}>
        {
          updatedCommunityList?.length > 1 &&
          <MySelect
            name="communityName"
            label="Community Name"
            value={{ label: `${communityName} (${communityCode})`, value: communityId }}
            setter={(val) => handleChange(val)}
            options={updatedCommunityList.map((item) => ({
              label: `${item?.communityName} (${item?.communityCode})`,
              value: item?.communityId,
            }))}
          />
        }
        {/* <div
          className={[classes.addMenuBtn, "c-p"].join(" ")}
          onClick={() => {
            getUserData();
            navigate("/");
            dispatch(activeCommunity({ isSetupCompleted: false, isSuperUser: true }));
            dispatch(setIsSkip(false));
            dispatch(setLastActiveCommunity(communitiesList?.find(
              (item) => item?.communityCode === communityCode
            )));
          }}
        >
          <HiOutlineViewGridAdd color="var(--secondary-color)" size={35} />
        </div> */}
      </div>
    </>
  );
};

export default ToggleCommunity;
